export default __webpack_public_path__ + "static/ptimms-3b3e40e2b7c57ec0b06d5f1795c8afde.png";